module.exports = __webpack_public_path__ + "media/2x/philadelphia-tribune@2x-470201cb.png";